import { render } from "./StandardButton.vue?vue&type=template&id=5d64430f&scoped=true"
import script from "./StandardButton.vue?vue&type=script&lang=js"
export * from "./StandardButton.vue?vue&type=script&lang=js"

import "./StandardButton.vue?vue&type=style&index=0&id=5d64430f&scoped=true&lang=css"

import exportComponent from "/Users/permartinson/Documents/GitHub/wpcedit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d64430f"]])

export default __exports__